import { makeStyles } from '@material-ui/core';

import { Content as BackstageContent } from '@backstage/core-components';

import type { ContentProps } from './Content';
import { NarrowBoxMui } from './NarrowBoxMui';

const useStyles = makeStyles({
  noPadding: {
    padding: '0 !important',
    '& > [class*="MuiStack-root"]': {
      padding: 0,
    },
  },
});

/** @deprecated Legacy MUI copy — migrate consumers to the Encore Content and delete. */
export const ContentMui = ({
  children,
  narrow,
  className,
  noPadding,
}: ContentProps) => {
  const classes = useStyles();
  return (
    <BackstageContent
      className={
        noPadding
          ? [classes.noPadding, className].filter(Boolean).join(' ')
          : className
      }
      noPadding={noPadding}
    >
      {narrow ? (
        <NarrowBoxMui width={typeof narrow === 'string' ? narrow : undefined}>
          {children}
        </NarrowBoxMui>
      ) : (
        children
      )}
    </BackstageContent>
  );
};
